"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadImage = void 0;
var loadImage = function (imageUrl) {
    return new Promise(function (resolve, reject) {
        var image = new window['Image']();
        image.src = imageUrl;
        image.onload = function () { return resolve(); };
        image.onerror = function () { return reject(new Error("Could not load image ".concat(imageUrl))); };
    });
};
exports.loadImage = loadImage;
//# sourceMappingURL=loadImage.js.map